import React, { Component } from "react";
import config from 'react-global-configuration';
import jwt_decode from "jwt-decode";
import axios from "axios";
import { connect } from "react-redux";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import * as moment from "moment";
import { BeatLoader } from "react-spinners";
import DateRangeFilter from '../filters/DateRangeFilter.jsx';
import MerchantFilter from '../filters/ServiceMerchantFilter.jsx';
import ChainFilter from '../filters/ChainFilter.jsx';
import StoreFilter from '../filters/ServiceStoreFilter.jsx';
import CityFilter from '../filters/CityFilter.jsx';
import MultiStateFilter from '../filters/MultiStateFilter.jsx';
import SingleCsvReportDownload from "../components/DownloadReport/SingleCsvReportDownload.jsx";
import { date_range_config } from '../helpers/utils.js';
import { PURPLE, HEADER_TH, TEXT_TD } from './reportConstants';

import LastRefresh from './LastRefresh.jsx';
const ROWS = 20;

const STATUS_OPTIONS = [
    { value: 'Open',      label: 'Open' },
    { value: 'Resolved',  label: 'Resolved' },
    { value: 'Pending',   label: 'Pending' },
    { value: 'QC Closed', label: 'QC Closed' },
    { value: 'Closed',    label: 'Closed' },
];

const diff        = moment().diff(moment().subtract(1, 'months'), 'days');
const date_config = date_range_config(diff, '1', '2020-01-01', '1');

const H = { ...HEADER_TH, whiteSpace: 'nowrap', fontSize: '12px' };
const C = { ...TEXT_TD,   fontSize: '12px', verticalAlign: 'middle' };

// ── Shared UI helpers ────────────────────────────────────────────────────────

function Spinner() {
    return <div style={{ textAlign: 'center', padding: '40px' }}><BeatLoader size={15} color="#51bcda" loading /></div>;
}
function ErrMsg({ msg }) {
    return <div className="alert alert-danger" style={{ margin: '15px' }}>{msg}</div>;
}
function EmptyMsg() {
    return <div style={{ textAlign: 'center', padding: '50px', color: '#888', fontSize: '14px' }}>No data available for the selected filters.</div>;
}
function Pager({ page, hasMore, count, onPrev, onNext }) {
    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '12px 16px', borderTop: '1px solid #e8e8e8', gap: '12px', backgroundColor: '#fafafa' }}>
            <span style={{ color: '#666', fontSize: '13px' }}>Page {page} &middot; {count} record{count !== 1 ? 's' : ''}</span>
            <button className="btn btn-sm btn-default" disabled={page === 1} onClick={onPrev}>&larr; Previous</button>
            <button className="btn btn-sm btn-default" disabled={!hasMore} onClick={onNext}>Next &rarr;</button>
        </div>
    );
}
const STATUS_COLORS = {
    'pending':   { color: '#D97706', bg: '#FFEBD5' },
    'open':      { color: '#2563EB', bg: '#DBEAFE' },
    'closed':    { color: '#007D2E', bg: '#DCFCE7' },
    'qc closed': { color: '#007D2E', bg: '#DCFCE7' },
    'resolved':  { color: '#7C3AED', bg: '#EDE9FE' },
};
function Badge({ value }) {
    if (!value) return <span style={{ color: '#bbb' }}>-</span>;
    const lower = value.toLowerCase();
    const style = STATUS_COLORS[lower];
    if (!style) return <span style={{ fontSize: '12px' }}>{value}</span>;
    return (
        <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: '600', color: style.color, backgroundColor: style.bg }}>
            {value}
        </span>
    );
}
function JobSheet({ url }) {
    if (!url) return <span style={{ color: '#bbb' }}>-</span>;
    return (
        <a href={url} target="_blank" rel="noopener noreferrer"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '4px 12px', background: PURPLE, color: '#fff', borderRadius: '4px', textDecoration: 'none', fontSize: '12px', fontWeight: '500' }}>
            <i className="fa fa-external-link" style={{ fontSize: '10px' }}></i> View
        </a>
    );
}

// ── Main component ───────────────────────────────────────────────────────────

class NTCTDashboard extends Component {
    constructor(props) {
        super(props);
        const isChurn = props.location && props.location.pathname.includes('ntct-churn');
        this.state = {
            activeTab:       isChurn ? 1 : 0,
            isFilterVisible: true,

            startDate:    date_config.start_date_value,
            endDate:      date_config.end_date_value,
            merchantID:   '',
            chainIDs:     '',
            storeID:      '',
            cityIDs:      '',
            stateIDs:     '',
            statusFilter: [],

            shipmentStatus:     '',
            storeCalloutStatus: '',
            beatplanStatus:     '',
            installationStatus: '',

            object_type: '', object_code: [], userType: '', user_id: '',

            isChange: false,

            rolloutData: [], rolloutLoading: false, rolloutError: null, rolloutPage: 1, rolloutHasMore: false,
            churnData:   [], churnLoading:   false, churnError:   null, churnPage:   1, churnHasMore:   false,

            // Server-side sort (data is paged): key = column header label, sent as `order`.
            rolloutSort: { key: null, dir: 'asc' },
            churnSort:   { key: null, dir: 'asc' },
        };
    }

    componentWillMount() {
        this.props.currentMenu("ntct_rollout_report");
        const decoded    = jwt_decode(localStorage.usertoken);
        const objectCode = decoded.object_code ? decoded.object_code.split(",") : [];
        this.setState({
            user_id:     decoded._id,
            object_type: decoded.object_type,
            object_code: objectCode,
            userType:    decoded.userType,
            merchantID:  decoded.object_type === 'Merchant' ? objectCode : '',
            storeID:     decoded.object_type === 'Store'    ? objectCode : '',
        }, () => {
            if (this.state.activeTab === 0) this.fetchRollout(1);
            else                            this.fetchChurn(1);
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location && this.props.location &&
            prevProps.location.pathname !== this.props.location.pathname) {
            const isChurn = this.props.location.pathname.includes('ntct-churn');
            this.setState({ activeTab: isChurn ? 1 : 0 });
        }
    }

    // ── Helpers ───────────────────────────────────────────────────────────────

    toArray = v => v ? (Array.isArray(v) ? v : [v]).filter(Boolean) : [];

    buildRolloutPayload(page, download = 0) {
        const { startDate, endDate, merchantID, chainIDs, storeID, cityIDs, stateIDs, statusFilter, shipmentStatus, storeCalloutStatus, beatplanStatus, installationStatus, rolloutSort } = this.state;
        return {
            page_number: page, rows_per_page: ROWS, search_query: "",
            ...(rolloutSort.key && { order: rolloutSort.key, order_type: rolloutSort.dir }),
            filters: {
                start_date: startDate, end_date: endDate,
                merchant_codes:       this.toArray(merchantID),
                chain_codes:          this.toArray(chainIDs),
                store_codes:          this.toArray(storeID),
                cities:               this.toArray(cityIDs),
                states:               this.toArray(stateIDs),
                parent_ticket_status: statusFilter.map(o => o.value),
                ...(shipmentStatus     && { shipment_status:      shipmentStatus }),
                ...(storeCalloutStatus && { store_callout_status: storeCalloutStatus }),
                ...(beatplanStatus     && { beatplan_status:      beatplanStatus }),
                ...(installationStatus && { installation_status:  installationStatus }),
                download, report_code: "rollout_ntcr_report",
            },
        };
    }

    buildChurnPayload(page, download = 0) {
        const { startDate, endDate, merchantID, chainIDs, storeID, cityIDs, stateIDs, statusFilter, churnSort } = this.state;
        return {
            page_number: page, rows_per_page: ROWS, search_query: "",
            ...(churnSort.key && { order: churnSort.key, order_type: churnSort.dir }),
            filters: {
                start_date: startDate, end_date: endDate,
                merchant_codes: this.toArray(merchantID),
                chain_codes:    this.toArray(chainIDs),
                store_codes:    this.toArray(storeID),
                cities:         this.toArray(cityIDs),
                states:         this.toArray(stateIDs),
                ticket_status:  statusFilter.map(o => o.value),
                download, report_code: "churn_request_report",
            },
        };
    }

    fetchRollout(page) {
        this.setState({ rolloutLoading: true, rolloutError: null });
        axios.post(config.get('API_URL') + '/InternalReport/get-rollout-ntcr-report', this.buildRolloutPayload(page), { headers: { Authorization: localStorage.usertoken } })
            .then(res => {
                const data = res.data && res.data.data ? res.data.data : [];
                this.setState({ rolloutData: data, rolloutLoading: false, rolloutPage: page, rolloutHasMore: data.length >= ROWS });
            })
            .catch(() => this.setState({ rolloutLoading: false, rolloutError: "Failed to load NTCT Rollout data." }));
    }

    fetchChurn(page) {
        this.setState({ churnLoading: true, churnError: null });
        axios.post(config.get('API_URL') + '/InternalReport/get-churn-request-report', this.buildChurnPayload(page), { headers: { Authorization: localStorage.usertoken } })
            .then(res => {
                const data = res.data && res.data.data ? res.data.data : [];
                this.setState({ churnData: data, churnLoading: false, churnPage: page, churnHasMore: data.length >= ROWS });
            })
            .catch(() => this.setState({ churnLoading: false, churnError: "Failed to load Churn Request data." }));
    }

    // ── Sorting ───────────────────────────────────────────────────────────────

    // Toggle asc/desc on the same column, start at asc on a new one, then reload page 1.
    handleSort = (tab, key) => {
        const field = tab === 'rollout' ? 'rolloutSort' : 'churnSort';
        const cur   = this.state[field];
        const dir   = cur.key === key && cur.dir === 'asc' ? 'desc' : 'asc';
        this.setState({ [field]: { key, dir } }, () => {
            if (tab === 'rollout') this.fetchRollout(1);
            else                   this.fetchChurn(1);
        });
    }

    renderSortTh(tab, label, extraStyle) {
        const { key, dir } = tab === 'rollout' ? this.state.rolloutSort : this.state.churnSort;
        const arrow = key === label
            ? <span style={{ marginLeft: '4px' }}>{dir === 'asc' ? '▲' : '▼'}</span>
            : <span style={{ color: '#ccc', marginLeft: '4px' }}>⇅</span>;
        return (
            <th key={label} style={{ ...H, ...extraStyle, cursor: 'pointer', userSelect: 'none' }}
                onClick={() => this.handleSort(tab, label)}>
                {label}{arrow}
            </th>
        );
    }

    // ── Tab / URL ─────────────────────────────────────────────────────────────

    handleTabSelect = (idx) => {
        this.setState({ activeTab: idx });
        const path = idx === 0 ? '/admin/ntct-rollout-report' : '/admin/ntct-churn-report';
        if (this.props.history) this.props.history.push(path);
        if (idx === 0 && !this.state.rolloutData.length && !this.state.rolloutLoading) this.fetchRollout(1);
        if (idx === 1 && !this.state.churnData.length   && !this.state.churnLoading)   this.fetchChurn(1);
    }

    // ── Filter handlers ───────────────────────────────────────────────────────

    handleDateRange = (endDate, startDate) => this.setState({ startDate, endDate, isChange: true });

    handleMerchant = (optionSelected, merchantID) => {
        this.setState({ merchantID, chainIDs: '', storeID: '', isChange: true });
        if (this.refs.chainFilter) this.refs.chainFilter.restChainFilter();
        if (this.refs.reloadStore) {
            this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code, false, '');
        }
    }

    handleChain  = (optionSelected, chainArray) => this.setState({ chainIDs: chainArray, isChange: true });
    handleStore  = (storeID)  => this.setState({ storeID, isChange: true });
    handleCity   = (optionSelected, cityArray) => this.setState({ cityIDs: cityArray, isChange: true });
    handleState  = (optionSelected, stateArray) => this.setState({ stateIDs: stateArray, isChange: true });
    handleStatus             = (selected) => this.setState({ statusFilter:        selected || [],  isChange: true });
    handleShipmentStatus     = (e)        => this.setState({ shipmentStatus:     e.target.value,  isChange: true });
    handleStoreCalloutStatus = (e)        => this.setState({ storeCalloutStatus: e.target.value,  isChange: true });
    handleBeatplanStatus     = (e)        => this.setState({ beatplanStatus:     e.target.value,  isChange: true });
    handleInstallationStatus = (e)        => this.setState({ installationStatus: e.target.value,  isChange: true });

    handleApply = () => {
        this.setState({ isChange: false });
        if (this.refs.statusSelect) this.refs.statusSelect.setState({ isOpen: false });
        if (this.refs.reloadStore)  this.refs.reloadStore.closeStoreList();
        if (this.state.activeTab === 0) this.fetchRollout(1);
        else                            this.fetchChurn(1);
    }

    handleReset = () => {
        if (this.refs.daterangeFilter) {
            this.refs.daterangeFilter.restDateFilter(
                date_config.start_date, date_config.end_date,
                date_config.display_start_date, date_config.display_end_date,
                date_config.start_date_value, date_config.end_date_value
            );
        }
        if (this.refs.merchantFilter) this.refs.merchantFilter.restMerchantFilter();
        if (this.refs.chainFilter) this.refs.chainFilter.restChainFilter();
        if (this.refs.reloadStore) {
            this.refs.reloadStore.getStore(
                this.state.object_code, this.state.object_type.toLowerCase(),
                this.state.object_type, this.state.object_code, false, ''
            );
        }
        if (this.refs.cityFilter)  this.refs.cityFilter.resetCityFilter();
        if (this.refs.multiStateFilter) this.refs.multiStateFilter.resetStateFilter();
        this.setState({
            startDate:    date_config.start_date_value,
            endDate:      date_config.end_date_value,
            merchantID:   this.state.object_type === 'Merchant' ? this.state.object_code : '',
            chainIDs:     '',
            storeID:      this.state.object_type === 'Store'    ? this.state.object_code : '',
            cityIDs:      '',
            stateIDs:     '',
            statusFilter:       [],
            shipmentStatus:     '',
            storeCalloutStatus: '',
            beatplanStatus:     '',
            installationStatus: '',
            isChange:           false,
        }, this.handleApply);
    }

    handleDownload = () => {
        const { startDate, endDate, merchantID, chainIDs, storeID, cityIDs, stateIDs, statusFilter, shipmentStatus, storeCalloutStatus, beatplanStatus, installationStatus } = this.state;
        const commonFilters = {
            start_date:     startDate,
            end_date:       endDate,
            merchant_codes: this.toArray(merchantID),
            chain_codes:    this.toArray(chainIDs),
            store_codes:    this.toArray(storeID),
            cities:         this.toArray(cityIDs),
            states:         this.toArray(stateIDs),
            download:       1,
        };
        if (this.state.activeTab === 0) {
            this.refs.csvDownload.downLoadReport(
                {
                    ...commonFilters,
                    parent_ticket_status: statusFilter.map(o => o.value),
                    report_code: 'rollout_ntcr_report',
                    ...(shipmentStatus     && { shipment_status:      shipmentStatus }),
                    ...(storeCalloutStatus && { store_callout_status: storeCalloutStatus }),
                    ...(beatplanStatus     && { beatplan_status:      beatplanStatus }),
                    ...(installationStatus && { installation_status:  installationStatus }),
                },
                '/internal_reports/get-rollout-ntcr-report', 'ntct_rollout_report', 9999
            );
        } else {
            this.refs.csvDownload.downLoadReport(
                { ...commonFilters, ticket_status: statusFilter.map(o => o.value), report_code: 'churn_request_report' },
                '/internal_reports/get-churn-request-report', 'churn_request_report', 9999
            );
        }
    }

    // ── Tab content renderers ─────────────────────────────────────────────────

    renderRollout() {
        const { rolloutData, rolloutLoading, rolloutError, rolloutPage, rolloutHasMore } = this.state;
        if (rolloutLoading)      return <Spinner />;
        if (rolloutError)        return <ErrMsg msg={rolloutError} />;
        if (!rolloutData.length) return <EmptyMsg />;
        return (
            <div>
                <div className="table-responsive" style={{ padding: 0 }}>
                    <table className="table" style={{ borderCollapse: 'collapse', width: '100%', minWidth: '1200px' }}>
                        <thead>
                            <tr style={{ backgroundColor: PURPLE }}>
                                {this.renderSortTh('rollout', 'Merchant Name')}
                                {this.renderSortTh('rollout', 'Chain Name')}
                                {this.renderSortTh('rollout', 'Store Name')}
                                {this.renderSortTh('rollout', 'City Name')}
                                {this.renderSortTh('rollout', 'State Name')}
                                {this.renderSortTh('rollout', 'Address', { minWidth: '180px' })}
                                {this.renderSortTh('rollout', 'UTID')}
                                {this.renderSortTh('rollout', 'Parent Ticket NTCR')}
                                {this.renderSortTh('rollout', 'Overall Ticket Status')}
                                {this.renderSortTh('rollout', 'Date of Parent Ticket Creation')}
                                {this.renderSortTh('rollout', 'Date of Shipment - Resolve')}
                                {this.renderSortTh('rollout', 'Agent name for shipment resolve')}
                                {this.renderSortTh('rollout', 'Store Callout Date - Resolve')}
                                {this.renderSortTh('rollout', 'Agent name for store call out resolve')}
                                {this.renderSortTh('rollout', 'Beat Plan Date')}
                                {this.renderSortTh('rollout', 'Date of installation')}
                                {this.renderSortTh('rollout', 'Agent name for installation')}
                                <th style={H}>Job Sheet</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rolloutData.map((row, idx) => (
                                <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f8f9fa' }}>
                                    <td style={C}>{row['Merchant Name'] || '-'}</td>
                                    <td style={C}>{row['Chain Name'] || '-'}</td>
                                    <td style={C}>{row['Store Name'] || '-'}</td>
                                    <td style={C}>{row['City Name'] || '-'}</td>
                                    <td style={C}>{row['State Name'] || '-'}</td>
                                    <td style={{ ...C, maxWidth: '220px', wordBreak: 'break-word', whiteSpace: 'normal' }}>{row['Address'] || '-'}</td>
                                    <td style={{ ...C, fontWeight: '600' }}>{row['UTID'] || '-'}</td>
                                    <td style={{ ...C, textAlign: 'center', fontWeight: '600' }}>
                                        {row['Parent Ticket NTCR'] ? (
                                            <a
                                                href={`https://innovitiservice.freshdesk.com/a/tickets/${row['Parent Ticket NTCR']}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: '#2563EB', textDecoration: 'underline', fontWeight: '600' }}
                                            >
                                                {row['Parent Ticket NTCR']}
                                            </a>
                                        ) : '-'}
                                    </td>
                                    <td style={{ ...C, textAlign: 'center' }}><Badge value={row['Overall Ticket Status']} /></td>
                                    <td style={{ ...C, textAlign: 'center' }}>{row['Date of Parent Ticket Creation'] || '-'}</td>
                                    <td style={{ ...C, textAlign: 'center' }}>{row['Date of Shipment - Resolve'] || '-'}</td>
                                    <td style={C}>{row['Agent name for shipment resolve'] || '-'}</td>
                                    <td style={{ ...C, textAlign: 'center' }}>{row['Store Callout Date - Resolve'] || '-'}</td>
                                    <td style={C}>{row['Agent name for store call out resolve'] || '-'}</td>
                                    <td style={{ ...C, textAlign: 'center' }}>{row['Beat Plan Date'] || '-'}</td>
                                    <td style={{ ...C, textAlign: 'center' }}>{row['Date of installation'] || '-'}</td>
                                    <td style={C}>{row['Agent name for installation'] || '-'}</td>
                                    <td style={{ ...C, textAlign: 'center' }}><JobSheet url={row['Job Sheet']} /></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <Pager page={rolloutPage} hasMore={rolloutHasMore} count={rolloutData.length}
                    onPrev={() => this.fetchRollout(rolloutPage - 1)}
                    onNext={() => this.fetchRollout(rolloutPage + 1)} />
            </div>
        );
    }

    renderChurn() {
        const { churnData, churnLoading, churnError, churnPage, churnHasMore } = this.state;
        if (churnLoading)      return <Spinner />;
        if (churnError)        return <ErrMsg msg={churnError} />;
        if (!churnData.length) return <EmptyMsg />;
        return (
            <div>
                <div className="table-responsive" style={{ padding: 0 }}>
                    <table className="table" style={{ borderCollapse: 'collapse', width: '100%' }}>
                        <thead>
                            <tr style={{ backgroundColor: PURPLE }}>
                                {this.renderSortTh('churn', 'Merchant Name')}
                                {this.renderSortTh('churn', 'Store Name')}
                                {this.renderSortTh('churn', 'Address', { minWidth: '180px' })}
                                {this.renderSortTh('churn', 'City Name')}
                                {this.renderSortTh('churn', 'State Name')}
                                {this.renderSortTh('churn', 'UTID')}
                                {this.renderSortTh('churn', 'Ticket ID')}
                                {this.renderSortTh('churn', 'Status')}
                            </tr>
                        </thead>
                        <tbody>
                            {churnData.map((row, idx) => (
                                <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f8f9fa' }}>
                                    <td style={C}>{row['Merchant Name'] || '-'}</td>
                                    <td style={C}>{row['Store Name'] || '-'}</td>
                                    <td style={{ ...C, maxWidth: '220px', wordBreak: 'break-word', whiteSpace: 'normal' }}>{row['Address'] || '-'}</td>
                                    <td style={C}>{row['City Name'] || '-'}</td>
                                    <td style={C}>{row['State Name'] || '-'}</td>
                                    <td style={{ ...C, fontWeight: '600' }}>{row['UTID'] || '-'}</td>
                                    <td style={{ ...C, fontWeight: '600', textAlign: 'center' }}>
                                        {row['Ticket ID'] ? (
                                            <a
                                                href={`https://innovitiservice.freshdesk.com/a/tickets/${row['Ticket ID']}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: '#2563EB',
                                                    textDecoration: 'underline',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {row['Ticket ID']}
                                            </a>
                                        ) : (
                                            '-'
                                        )}
                                    </td>
                                    <td style={{ ...C, textAlign: 'center' }}><Badge value={row['Status']} /></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <Pager page={churnPage} hasMore={churnHasMore} count={churnData.length}
                    onPrev={() => this.fetchChurn(churnPage - 1)}
                    onNext={() => this.fetchChurn(churnPage + 1)} />
            </div>
        );
    }

    renderFilters() {
        const { activeTab, object_type, object_code, userType, statusFilter, shipmentStatus, storeCalloutStatus, beatplanStatus, installationStatus } = this.state;
        const labelStyle  = { fontSize: '11px', fontWeight: '600', color: '#555' };
        const colStyle    = { width: '16.66%', padding: '0 5px 10px' };
        const selectStyle = {
            width: '100%', height: '38px', padding: '0 8px', fontSize: '13px',
            border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff', color: '#333',
        };
        return (
            <div className="content" style={{ backgroundColor: '#f5f5f5', padding: '15px 20px 5px', marginBottom: '10px' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end' }}>

                    {/* Row 1: Date + Merchant / Chain / Store + State + City */}
                    <div style={{ ...colStyle, position: 'relative' }} className="date-icon-small">
                        <label style={labelStyle}>Ticket Created At</label>
                        <DateRangeFilter ref="daterangeFilter" onSelectDate={this.handleDateRange}
                            start_date={date_config.start_date} end_date={date_config.end_date}
                            display_start_date={date_config.display_start_date}
                            display_end_date={date_config.display_end_date}
                            start_date_limit={date_config.start_date_limit} />
                    </div>

                    {object_type === 'Innoviti' && (
                        <div style={colStyle}>
                            <label style={labelStyle}>Merchant</label>
                            <MerchantFilter ref="merchantFilter" onSelectMerchant={this.handleMerchant}
                                object_type={object_type} object_code={object_code} user_type={userType} />
                        </div>
                    )}

                    {(object_type === 'Innoviti' || object_type === 'Merchant') && (
                        <div style={colStyle}>
                            <label style={labelStyle}>Chain</label>
                            <ChainFilter ref="chainFilter" onSelectChain={this.handleChain}
                                object_type={object_type} object_code={object_code} user_type={userType} />
                        </div>
                    )}

                    {(object_type === 'Innoviti' || object_type === 'Merchant' || object_type === 'Chain') && (
                        <div style={colStyle}>
                            <label style={labelStyle}>Store</label>
                            <StoreFilter ref="reloadStore" onSelectStore={this.handleStore}
                                object_type={object_type} object_code={object_code} user_type={userType} />
                        </div>
                    )}

                    <div style={colStyle}>
                        <label style={labelStyle}>State</label>
                        <MultiStateFilter ref="multiStateFilter" onSelectState={this.handleState} userType={userType} />
                    </div>

                    <div style={colStyle}>
                        <label style={labelStyle}>City</label>
                        <CityFilter ref="cityFilter" onSelectCity={this.handleCity} />
                    </div>

                    {/* Row 2: Ticket Status + rollout-only filters + buttons */}
                    <div style={colStyle}>
                        <label style={labelStyle}>Ticket Status</label>
                        <ReactMultiSelectCheckboxes ref="statusSelect" isMulti value={statusFilter} options={STATUS_OPTIONS}
                            onChange={this.handleStatus} placeholderButtonLabel="Select [Status]"
                            className="report-listbox" isClearable={true} />
                    </div>

                    {activeTab === 0 && (
                        <React.Fragment>
                            <div style={colStyle}>
                                <label style={labelStyle}>Shipment Status</label>
                                <select value={shipmentStatus} onChange={this.handleShipmentStatus} style={selectStyle}>
                                    <option value="">All</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Done">Done</option>
                                </select>
                            </div>

                            <div style={colStyle}>
                                <label style={labelStyle}>Store Callout Status</label>
                                <select value={storeCalloutStatus} onChange={this.handleStoreCalloutStatus} style={selectStyle}>
                                    <option value="">All</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Done">Done</option>
                                </select>
                            </div>

                            <div style={colStyle}>
                                <label style={labelStyle}>Beat Plan Status</label>
                                <select value={beatplanStatus} onChange={this.handleBeatplanStatus} style={selectStyle}>
                                    <option value="">All</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Done">Done</option>
                                </select>
                            </div>

                            <div style={colStyle}>
                                <label style={labelStyle}>Installation Status</label>
                                <select value={installationStatus} onChange={this.handleInstallationStatus} style={selectStyle}>
                                    <option value="">All</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Done">Done</option>
                                </select>
                            </div>
                        </React.Fragment>
                    )}

                    <div style={{ marginLeft: 'auto', padding: '0 5px 10px', display: 'flex', alignItems: 'flex-end', whiteSpace: 'nowrap' }}>
                        <button type="button" className="primary apply-filter" onClick={this.handleApply}>Apply</button>
                        &nbsp;
                        <button type="button" className="primary reset-filter" onClick={this.handleReset}>Reset</button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { activeTab, isFilterVisible } = this.state;
        return (
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title service-title">NTCR & Churn Report</h4>
                                        <LastRefresh />
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        <div className="report-header-icons">
                                            <div className="icon-button filter-icon" title="Toggle Filters"
                                                onClick={() => this.setState(p => ({ isFilterVisible: !p.isFilterVisible }))}>
                                                <i className="fa fa-filter"></i>
                                            </div>
                                            <div className="icon-button refresh-icon" title="Refresh" onClick={this.handleApply}>
                                                <i className="fa fa-refresh"></i>
                                            </div>
                                            <div className="icon-button download-icon" title="Download Report" onClick={this.handleDownload}>
                                                <i className="fa fa-download"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix"></div>

                                <div className="content-service">
                                    {isFilterVisible && this.renderFilters()}
                                    <div className="clearfix"></div>
                                    <div className="row"><div className="ro-sep-service-pages"></div></div>
                                    <div className="clearfix"></div>

                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <Tabs selectedIndex={activeTab} onSelect={this.handleTabSelect}>
                                            <TabList>
                                                <Tab>NTCR Ticket Roll Out</Tab>
                                                <Tab>Churn Request Report</Tab>
                                            </TabList>
                                            <TabPanel>{activeTab === 0 && this.renderRollout()}</TabPanel>
                                            <TabPanel>{activeTab === 1 && this.renderChurn()}</TabPanel>
                                        </Tabs>
                                    </div>
                                </div>

                                <div className="footer"><div className="stats"><i></i></div></div>
                                <SingleCsvReportDownload ref="csvDownload" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    currentMenu: (name) => dispatch({ type: 'change_menu', payload: name })
});

export default connect(null, mapDispatchToProps)(NTCTDashboard);
